// TV-feestgeluiden: ingebouwde WebAudio-synths + eigen mp3-URL per triggertype.
export const SOUND_OPTIONS = [
  { id: "fanfare", label: "Fanfare (stadion)" },
  { id: "jingle", label: "Jingle (kort)" },
  { id: "kassa", label: "Kassa (cha-ching)" },
  { id: "airhorn", label: "Airhorn" },
  { id: "tada", label: "Tada!" },
  { id: "url", label: "Eigen mp3-URL…" },
];

const audioCtx = () => new (window.AudioContext || window.webkitAudioContext)();

export function playFanfare() {
  try {
    const ctx = audioCtx();
    const note = (freq, t, dur, gainV = 0.22, type = "sawtooth") => {
      const o = ctx.createOscillator(), g = ctx.createGain();
      o.type = type; o.frequency.value = freq;
      g.gain.setValueAtTime(0, ctx.currentTime + t);
      g.gain.linearRampToValueAtTime(gainV, ctx.currentTime + t + 0.04);
      g.gain.exponentialRampToValueAtTime(0.001, ctx.currentTime + t + dur);
      o.connect(g); g.connect(ctx.destination);
      o.start(ctx.currentTime + t); o.stop(ctx.currentTime + t + dur + 0.1);
    };
    const chord = (freqs, t, dur, gainV) => freqs.forEach((f) => note(f, t, dur, gainV));
    chord([392, 494, 587], 0.0, 0.45);
    chord([440, 554, 659], 0.5, 0.45);
    chord([494, 587, 740], 1.0, 0.45);
    chord([523, 659, 784], 1.5, 1.6, 0.28);
    chord([261, 330, 392, 523], 1.5, 1.6, 0.10);
    note(1046, 1.5, 1.4, 0.10, "triangle");
  } catch { /* audio niet beschikbaar */ }
}

export function playJingle() {
  try {
    const ctx = audioCtx();
    [[523, 0], [659, 0.15], [784, 0.3], [1046, 0.45]].forEach(([f, t]) => {
      const o = ctx.createOscillator(), g = ctx.createGain();
      o.type = "triangle"; o.frequency.value = f;
      g.gain.setValueAtTime(0, ctx.currentTime + t);
      g.gain.linearRampToValueAtTime(0.2, ctx.currentTime + t + 0.03);
      g.gain.exponentialRampToValueAtTime(0.001, ctx.currentTime + t + 0.5);
      o.connect(g); g.connect(ctx.destination);
      o.start(ctx.currentTime + t); o.stop(ctx.currentTime + t + 0.6);
    });
  } catch { /* audio niet beschikbaar */ }
}

export function playKassa() {
  try {
    const ctx = audioCtx();
    const ding = (f, t) => {
      [[f, "square", 0.16, 0.35], [f * 2.76, "sine", 0.08, 0.3]].forEach(([freq, type, gainV, dur]) => {
        const o = ctx.createOscillator(), g = ctx.createGain();
        o.type = type; o.frequency.value = freq;
        g.gain.setValueAtTime(0, ctx.currentTime + t);
        g.gain.linearRampToValueAtTime(gainV, ctx.currentTime + t + 0.01);
        g.gain.exponentialRampToValueAtTime(0.001, ctx.currentTime + t + dur);
        o.connect(g); g.connect(ctx.destination);
        o.start(ctx.currentTime + t); o.stop(ctx.currentTime + t + dur + 0.05);
      });
    };
    ding(1318, 0); ding(1318, 0.12);
    const thud = ctx.createOscillator(), tg = ctx.createGain();
    thud.type = "triangle";
    thud.frequency.setValueAtTime(180, ctx.currentTime + 0.28);
    thud.frequency.exponentialRampToValueAtTime(70, ctx.currentTime + 0.5);
    tg.gain.setValueAtTime(0, ctx.currentTime + 0.28);
    tg.gain.linearRampToValueAtTime(0.25, ctx.currentTime + 0.3);
    tg.gain.exponentialRampToValueAtTime(0.001, ctx.currentTime + 0.55);
    thud.connect(tg); tg.connect(ctx.destination);
    thud.start(ctx.currentTime + 0.28); thud.stop(ctx.currentTime + 0.6);
  } catch { /* audio niet beschikbaar */ }
}

export function playAirhorn() {
  try {
    const ctx = audioCtx();
    const blast = (t, dur) => {
      [415, 417.5, 830].forEach((f, i) => {
        const o = ctx.createOscillator(), g = ctx.createGain();
        o.type = "sawtooth";
        o.frequency.setValueAtTime(f * 0.97, ctx.currentTime + t);
        o.frequency.linearRampToValueAtTime(f, ctx.currentTime + t + 0.05);
        const v = i === 2 ? 0.06 : 0.16;
        g.gain.setValueAtTime(0, ctx.currentTime + t);
        g.gain.linearRampToValueAtTime(v, ctx.currentTime + t + 0.03);
        g.gain.setValueAtTime(v, ctx.currentTime + t + dur - 0.08);
        g.gain.exponentialRampToValueAtTime(0.001, ctx.currentTime + t + dur);
        o.connect(g); g.connect(ctx.destination);
        o.start(ctx.currentTime + t); o.stop(ctx.currentTime + t + dur + 0.05);
      });
    };
    blast(0, 0.35); blast(0.45, 0.35); blast(0.9, 1.1);
  } catch { /* audio niet beschikbaar */ }
}

export function playTada() {
  try {
    const ctx = audioCtx();
    const note = (f, t, dur, gainV = 0.2, type = "triangle") => {
      const o = ctx.createOscillator(), g = ctx.createGain();
      o.type = type; o.frequency.value = f;
      g.gain.setValueAtTime(0, ctx.currentTime + t);
      g.gain.linearRampToValueAtTime(gainV, ctx.currentTime + t + 0.03);
      g.gain.exponentialRampToValueAtTime(0.001, ctx.currentTime + t + dur);
      o.connect(g); g.connect(ctx.destination);
      o.start(ctx.currentTime + t); o.stop(ctx.currentTime + t + dur + 0.1);
    };
    note(523, 0, 0.28, 0.22, "sawtooth");
    [523, 659, 784, 1046].forEach((f) => note(f, 0.3, 1.4, 0.14));
    note(2093, 0.3, 1.2, 0.05, "sine");
  } catch { /* audio niet beschikbaar */ }
}

const BUILTIN = { fanfare: playFanfare, jingle: playJingle, kassa: playKassa, airhorn: playAirhorn, tada: playTada };

let currentAudio = null;

function reportAudioIssue(reason, detail = "") {
  // Stille vieringen nooit onopgemerkt: backend post (met throttle) een Slack-waarschuwing.
  import("@/lib/api").then(({ default: api }) =>
    api.post("/tv/audio-issue", { reason, detail }).catch(() => {})).catch(() => {});
}

export function playUrl(url, _ms = 8000, report = true) {
  // Speel het (door het team geknipte) fragment volledig af — de popup-duur is geen
  // muziek-limiet. Globale ref voorkomt GC/overlap; veiligheidscap 90s.
  if (currentAudio) { try { currentAudio.pause(); } catch { /* al gestopt */ } }
  const a = new Audio(url);
  currentAudio = a;
  a.volume = 0.9;
  a.onended = () => { if (currentAudio === a) currentAudio = null; };
  // Kapotte/verwijderde track (404/500 of stream-fout ná play()): val terug op fanfare
  // i.p.v. een stille viering, en meld het zodat de bibliotheek opgeruimd kan worden.
  a.onerror = () => {
    if (currentAudio === a) currentAudio = null;
    if (report) reportAudioIssue("track_error", url);
    playFanfare();
  };
  a.play().catch((err) => {
    if (report) reportAudioIssue(String(err?.name) === "NotAllowedError" ? "autoplay_blocked" : "play_failed", url);
    playFanfare();
  });
  setTimeout(() => { if (currentAudio === a) { a.pause(); currentAudio = null; } }, 90000);
}

export function stopCelebrationSound() {
  // Popup dicht = feest klaar: eventueel nog spelende feesttrack netjes stoppen.
  if (currentAudio) { try { currentAudio.pause(); } catch { /* al gestopt */ } currentAudio = null; }
}

export function playRandomFromLibrary(ms = 8000, report = true) {
  import("@/lib/api").then(({ default: api }) =>
    api.get("/tv/sounds/random")
      .then(({ data }) => (data.url ? playUrl(data.url, ms, report) : playFanfare()))
      .catch(() => playFanfare()));
}

// cfg = {type, url} uit tv_config.sounds; zonder cfg geldt het oude standaardgedrag
import { isSoundEnabled } from "./sound";

export function playCelebration(cfg, kind, legacyTuneUrl, ms = 8000, { force = false, report = true } = {}) {
  // Academy-mute (speaker in de koptekst) respecteren; de TV heeft een eigen geluidsknop en
  // expliciete "beluister"-knoppen spelen altijd (force).
  if (!force && !isSoundEnabled()) return;
  if (cfg && cfg.enabled === false) return; // geluid uitgezet voor dit feestmoment
  if (cfg?.type === "random") return playRandomFromLibrary(ms, report);
  if (cfg?.type === "url" && cfg.url) return playUrl(cfg.url, ms, report);
  if (cfg?.type && BUILTIN[cfg.type]) return BUILTIN[cfg.type]();
  if (["deal", "sku", "milestone", "streak"].includes(kind)) return legacyTuneUrl ? playUrl(legacyTuneUrl, ms, report) : playFanfare();
  return playJingle();
}
